export default __webpack_public_path__ + "static/img-app-deployment-0b06e5e80c907bbad0c5121cc0b53ed3.jpg";